var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "admin-preview" },
    [
      _c("div", { staticClass: "a-card pv-bar" }, [
        _c("button", { staticClass: "a-btn", on: { click: _vm.back } }, [
          _vm._v("← 返回列表"),
        ]),
        _c(
          "button",
          {
            staticClass: "a-btn",
            attrs: { disabled: !_vm.page },
            on: { click: _vm.edit },
          },
          [_vm._v("编辑此页")]
        ),
        _c(
          "button",
          {
            staticClass: "a-btn",
            attrs: { disabled: !_vm.isPublished },
            on: { click: _vm.openSite },
          },
          [_vm._v("在新窗口打开前台")]
        ),
        _c("span", { staticClass: "grow" }),
        _vm.page
          ? _c(
              "span",
              { staticClass: "pv-meta" },
              [
                _vm._v(
                  " 主题 " +
                    _vm._s(_vm.page.theme) +
                    " · 状态 " +
                    _vm._s(_vm.statusLabel(_vm.page.status)) +
                    " · 浏览 " +
                    _vm._s(_vm.page.viewcount) +
                    " "
                ),
                !_vm.isPublished
                  ? [_vm._v("（未发布，前台暂不可见）")]
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
      ]),
      _vm.loading
        ? _c("div", { staticClass: "a-empty" }, [_vm._v("正在加载…")])
        : !_vm.page
        ? _c("div", { staticClass: "a-empty" }, [
            _vm._v(_vm._s(_vm.error || "页面不存在")),
          ])
        : _c("div", { staticClass: "phone-wrap" }, [
            _c("div", { staticClass: "phone" }, [
              _c("div", { staticClass: "phone-notch" }),
              _c(
                "div",
                { staticClass: "phone-screen", class: _vm.page.theme },
                [
                  _vm.page.theme === "rose"
                    ? _c(
                        "div",
                        { staticClass: "petals" },
                        _vm._l(14, function (n) {
                          return _c("span", {
                            key: n,
                            style: _vm.petalStyle(n),
                          })
                        }),
                        0
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "screen-inner" }, [
                    _vm.page.nameText
                      ? _c("div", { staticClass: "pv-name" }, [
                          _vm._v(_vm._s(_vm.page.nameText)),
                        ])
                      : _vm._e(),
                    _c("h1", { staticClass: "pv-title" }, [
                      _vm._v(_vm._s(_vm.page.title)),
                    ]),
                    _vm.page.subtitle
                      ? _c("div", { staticClass: "pv-sub" }, [
                          _vm._v(_vm._s(_vm.page.subtitle)),
                        ])
                      : _vm._e(),
                    _vm.page.date
                      ? _c("div", { staticClass: "pv-date" }, [
                          _vm._v(_vm._s(_vm.page.date)),
                        ])
                      : _vm._e(),
                    _vm.verses.length
                      ? _c(
                          "div",
                          { staticClass: "pv-verses" },
                          [
                            _vm._l(_vm.verses, function (v, i) {
                              return _c(
                                "div",
                                { key: "v" + i, staticClass: "pv-verse" },
                                [_vm._v(_vm._s(v))]
                              )
                            }),
                            _vm.page.verseFrom
                              ? _c("div", { staticClass: "pv-from" }, [
                                  _vm._v("—— " + _vm._s(_vm.page.verseFrom)),
                                ])
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "pv-body" },
                      _vm._l(_vm.paragraphs, function (p, i) {
                        return _c("p", { key: "p" + i, staticClass: "pv-p" }, [
                          _vm._v(_vm._s(p)),
                        ])
                      }),
                      0
                    ),
                    _vm.page.sign || _vm.page.signDate
                      ? _c("div", { staticClass: "pv-divider" }, [
                          _c("span", [_vm._v("❦")]),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "pv-sign" }, [
                      _vm.page.sign
                        ? _c("div", { staticClass: "s-name" }, [
                            _vm._v(_vm._s(_vm.page.sign)),
                          ])
                        : _vm._e(),
                      _vm.page.signDate
                        ? _c("div", { staticClass: "s-date" }, [
                            _vm._v("——" + _vm._s(_vm.page.signDate)),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]
              ),
            ]),
          ]),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.toast
          ? _c("div", { staticClass: "a-toast", class: _vm.toast.type }, [
              _vm._v(_vm._s(_vm.toast.text)),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }